import { Box, Backdrop, CircularProgress, Grid, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "./quota-details.css";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";
import MultiSelectSKUFilter from "./MultiSelectSKUFilter";
import MultiSelectScenarioFilter from "./MultiSelectScenarioFilter";
import MultiSelectCustomerFilter from "./MultiSelectCustomerFilter";
import SingleSelectConsumptionFilter from "./SingleSelectConsumptionFilter";
import { setState, ExportFileForQuotaDetails } from "../analyzeSlice";
import { useDispatch } from "react-redux";
import CollapseSection from "../../../components/ui/CollapseSection";

export default function Table() {
	const { quotaDetailsDataPrepared } = useSelector((store) => store.analyze);
	let rows = quotaDetailsDataPrepared ? quotaDetailsDataPrepared.rows : [];
	const dispatch = useDispatch();
	// let columns = quotaDetailsDataPrepared
	// 	? quotaDetailsDataPrepared.columns
	// 	: [];
	const state = useSelector((store) => store.analyze);
	const {
		selectedSKUDesFilter,
		selectedScnarioFilter,
		selectedCustomerFilter,
		selectedOprConsFilter,
		selectedConsValFilter,
		selectedCountry,
		duration,
		isLoading,
		showOrHideExport,
		redirectedQDLoading,
	} = state;

	const [updatedGridData, setUpdatedGridData] = useState([]);
	//const [showOrHideExport, setShowOrHideExport] = useState(false);
	let lstGrdFilteredData = [];

	const columns = [
		{
			field: "scenarioName",
			headerName: "Scenario Name",
			flex: 2,
			minWidth: 150,
			disableColumnMenu: true,
			renderHeader: (params) => {
				return (
					<div>
						<strong>Scenario Name</strong>
						<MultiSelectScenarioFilter getSKUData={rows} />
					</div>
				);
			},
		},
		{
			field: "sku",
			headerName: "SKU Description",
			flex: 2,
			minWidth: 150,
			disableColumnMenu: true,
			renderHeader: (params) => {
				return (
					<div>
						<strong>SKU Description</strong>
						<MultiSelectSKUFilter getSKUData={rows} />
					</div>
				);
			},

			valueGetter: (params) => {
				if (params.row.skuName && params.row.skuName !== "") {
					return `${params.row.skuName} (${params.row.skuNumber})`;
				}
				return "";
			},
		},
		{
			field: "customer",
			headerName: "Customer Description",
			flex: 2,
			minWidth: 150,
			disableColumnMenu: true,
			renderHeader: (params) => {
				return (
					<div>
						<strong>Customer Description</strong>
						<MultiSelectCustomerFilter getSKUData={rows} />
					</div>
				);
			},
			valueGetter: (params) => {
				if (params.row.customerName && params.row.customerName !== "") {
					return `${params.row.customerName} (${params.row.customerNumber})`;
				}
				return "";
			},
		},
		{
			field: "depletionModel",
			headerName: "Depletion Type",
			flex: 1,
			minWidth: 120,
			disableColumnMenu: true,
			valueGetter: (params) =>
				params.row.depletionModel ?? params.row.DepletionModel ?? "",
		},
		{
			field: "quota",
			headerName: "Quota",
			flex: 1,
			minWidth: 150,
			disableColumnMenu: true,
		},
		{
			field: "efs",
			headerName: "EFS",
			flex: 1,
			minWidth: 150,
			disableColumnMenu: true,
		},
		{
			field: "consumption",
			headerName: "Consumption",
			flex: 1,
			minWidth: 150,
			disableColumnMenu: true,
			renderHeader: (params) => {
				return (
					<div>
						<strong>Consumption</strong>
						<SingleSelectConsumptionFilter getSKUData={rows} />
					</div>
				);
			},
			valueGetter: (params) => {
				return `${params.row.consumption}%`;
			},
		},
	];

	// useEffect(() => {
	// 	debugger;
	// 	rows=[];
	// 	  setUpdatedGridData([]);
	//   }, []);

	useEffect(() => {
		// Reset the state when the component mounts
		dispatch(setState("selectedOprConsFilter", ""));
		dispatch(setState("selectedConsValFilter", ""));
	}, []);

	useEffect(() => {
		filterGridDatabyReplace();
	}, [
		selectedSKUDesFilter,
		selectedScnarioFilter,
		selectedCustomerFilter,
		selectedOprConsFilter,
		selectedConsValFilter,
	]);

	function filterGridDatabyReplace() {
		lstGrdFilteredData = rows;

		if (selectedSKUDesFilter !== undefined && selectedSKUDesFilter.length > 0)
			lstGrdFilteredData = rows.filter((x) =>
				selectedSKUDesFilter.includes(x.skuName)
			);

		if (selectedScnarioFilter !== undefined && selectedScnarioFilter.length > 0)
			lstGrdFilteredData = lstGrdFilteredData.filter((x1) =>
				selectedScnarioFilter.includes(x1.scenarioName)
			);

		if (
			selectedCustomerFilter !== undefined &&
			selectedCustomerFilter.length > 0
		)
			lstGrdFilteredData = lstGrdFilteredData.filter((x1) =>
				selectedCustomerFilter.includes(x1.customerName)
			);

		if (
			selectedConsValFilter !== undefined &&
			selectedConsValFilter.length > 0 &&
			selectedOprConsFilter !== undefined &&
			selectedOprConsFilter.length > 0
		) {
			lstGrdFilteredData = filterConsumtion(
				selectedOprConsFilter,
				Number(selectedConsValFilter)
			);
		}

		setUpdatedGridData(lstGrdFilteredData);
	}

	const filterConsumtion = (operator, value) => {
		switch (operator) {
			case "=":
				return lstGrdFilteredData.filter((data) => data.consumption === value);
			case ">":
				return lstGrdFilteredData.filter((data) => data.consumption > value);
			case "<":
				return lstGrdFilteredData.filter((data) => data.consumption < value);
			case ">=":
				return lstGrdFilteredData.filter((data) => data.consumption >= value);
			case "<=":
				return lstGrdFilteredData.filter((data) => data.consumption <= value);
			default:
				return lstGrdFilteredData;
		}
	};

	async function exportDataAsFile(isPdf) {

		const filteredData = updatedGridData?.map(item => ({
			scenarioName: item.scenarioName,
			sku: item.skuName ? item.skuName + ' (' + item.skuNumber + ')' : "",
			customer: item.customerName ? item.customerName + ' (' + item.customerNumber + ')' : "",
			depletionModel: item.depletionModel ?? "",
			quota: item.quota,
			efs: item.efs,
			consumption: item.consumption + '%'
		}));

		const obj = {
			isPdf,
			AnalyzeTitle: "Quota Details",
			CountryName: selectedCountry,
			Period: duration,
			listAnalyseData: filteredData
		};
		//setIsLoading(true);
		dispatch(ExportFileForQuotaDetails(obj))
		//.then(() => setIsLoading(false));
	}

	// console.log(showOrHideExport)
	//if (quotaDetailsDataPrepared && rows && columns) {
	return (
		<div style={{marginTop:"40px"}}>
		<CollapseSection title="Quota Detais">
		<Box>
			<Grid container justifyContent={"flex-end"}>
				{showOrHideExport && (
					<Box>
						<IconButton onClick={(e) => exportDataAsFile(false)}>
							<GridOnIcon sx={{ color: "green.main" }} />
						</IconButton>
						<IconButton onClick={(e) => exportDataAsFile(true)}>
							<PictureAsPdfIcon sx={{ color: "red.main" }} />
						</IconButton>
					</Box>
				)}
			</Grid>
			{
				redirectedQDLoading ? (
					<Box>
						<Backdrop
							sx={{
								color: "#fff",
								zIndex: (theme) => theme.zIndex.drawer + 1,
							}}
							open={redirectedQDLoading}
						>
							<CircularProgress />
						</Backdrop>
					</Box>
				) : (
					<Box sx={{ mt: 3 }}>
						{quotaDetailsDataPrepared && rows && columns ?
							<DataGrid
								//rows={rows}
								rows={updatedGridData}
								columns={columns}
								getRowClassName={(params) => {
									return params.row.customerName === ""
										? "highlight-row highlight-row:hover"
										: "";
								}}
								disableColumnMenu
								disableRowSelectionOnClick
							/> : <></>}
					</Box>
				)
			}
		</Box >
		</CollapseSection>
		</div>
	)
	//}
	return null;

}
